export enum ShareItem {
    CUSTOMER = 'customer',
    DEALER = 'dealer'
}
